
import { RefreshIcon } from '@heroicons/vue/outline'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoadingComponent',
  components: { RefreshIcon },
})
